import React, {createContext, useContext, useState, useCallback, ReactNode} from "react";

interface SettingsContextType {
  isModalOpen: boolean;
  openSettings: () => void;
  closeSettings: () => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(undefined);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};

interface SettingsProviderProps {
  children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({children}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openSettings = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const closeSettings = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const value = {
    isModalOpen,
    openSettings,
    closeSettings
  };

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};
